// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"88":"2a1254ac","215":"1756b252","230":"9e55a001","491":"1912759f","563":"67116bc4","685":"0ccfb9b1","722":"3a7b8ef9","976":"be722004"}[chunkId] + ".chunk.js";
};